"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FuseNavbarModule = /** @class */ (function () {
    function FuseNavbarModule() {
    }
    return FuseNavbarModule;
}());
exports.FuseNavbarModule = FuseNavbarModule;
